import * as React from "react"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

const DEFAULT_DELAY_MS = 350

/**
 * AutocompleteAsyncSeeker with the ajax call debounced.
 *
 * The plain component re-runs its ajax effect on every input change, and the
 * AbortController it uses only cancels the browser side of the request: the API
 * still executes each one. Typing "rabanne" fired 7 concurrent requests, which on
 * a 320m-CPU pod queued up to ~9 s for the last one.
 *
 * `waiting` is the lever the component exposes to skip a fetch, so hold it up
 * while the user types and drop it once they stop — the input itself is
 * uncontrolled here, so nothing lags visually.
 */
export default function AutocompleteAsyncDebounced({ delay = DEFAULT_DELAY_MS, onInputChange, ...props }) {
	const [typing, setTyping] = React.useState(false)
	const timer = React.useRef(null)

	React.useEffect(() => () => clearTimeout(timer.current), [])

	const handleInputChange = (event, value, reason) => {
		onInputChange && onInputChange(event, value, reason)
		setTyping(true)
		clearTimeout(timer.current)
		timer.current = setTimeout(() => setTyping(false), delay)
	}

	return <AutocompleteAsyncSeeker
		{...props}
		waiting={typing}
		onInputChange={handleInputChange}
	/>
}
